<template>
  <v-dialog
    :model-value="errorDialog.dialogVisible.value"
    max-width="800px"
    persistent
    scrollable
    class="error-dialog">
    <v-card>
      <v-toolbar color="error" density="compact">
        <v-icon size="small" icon="mdi-alert" class="ml-4"></v-icon>
        <v-toolbar-title>{{ errorDialog.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn size="small" icon="mdi-close" @click="errorDialog.close"></v-btn>
      </v-toolbar>
      <v-card-text class="error-message">
        <template v-if="errorDialog.mandatoryFields.value.length > 0">
          <p class="error-label"><strong>Mandatory Fields:</strong></p>
          <table class="mandatory-fields-table">
            <tr v-for="errField in errorDialog.mandatoryFields.value">
              <td>{{ errField }}</td>
            </tr>
          </table>
        </template>
        <template v-if="errorDialog.invalidFields.value.length > 0">
          <p class="error-label"><strong>Invalid Fields:</strong></p>
          <table class="invalid-fields-table">
            <tr v-for="errField in errorDialog.invalidFields.value">
              <td>{{ errField.label }}</td>
              <td>{{ errField.error }}</td>
            </tr>
          </table>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { useErrorDialog } from "./use_error_dialog";

const errorDialog = useErrorDialog();
</script>
<style scoped lang="scss">
.error-message {
  white-space: pre-line;
}

.error-label {
  font-size: 14px;
}

.mandatory-fields-table {
  margin-bottom: 8px;
}

.mandatory-fields-table,
.invalid-fields-table {
  width: 100%;
  border-collapse: collapse;

  tr {
    border: 1px solid #ccc;
  }

  td {
    padding: 2px 8px;
    font-size: 13px;
  }
}
</style>
